<template>
  <div>
    <div id="map"></div>

    <div class="menu">
      <div class="item" v-for="item in typeList" :key="item.value" :class="selected === item.value ? 'active' : ''"
        @click="onSelect(item.value)" >{{ item.name }}</div>
    </div>

    <Detail :detail="detail" />
  </div>
</template>
<script>
import Detail from "./components/detail.vue";

import request from "@/api/request";
export default {
  components: {
    Detail,
  },

  data() {
    return {
      typeList: [
        {
          name: "cod",
          value: "cod",
        },
        {
          name: "orp",
          value: "orp",
        },
        {
          name: "氨氮",
          value: "nh4n",
        },
        {
          name: "酸碱度",
          value: "ph",
        },
        {
          name: "溶解氧",
          value: "doxygen",
        },
        {
          name: "透明度",
          value: "ss",
        },
      ],
      selected: "cod",
      list: [],
      detail: {},
    };
  },

  watch: {
    detail: {
      handler() {
        this.addMarker();
      },
      deep: true,
    },
  },
  mounted() {
    this.initMap();

    request({
      url: "/model-analysis/pipe/device/query/realtime/type/waterquality",
    }).then((res) => {
      if (Array.isArray(res) && res.length > 0) {
        this.list = res;
        this.detail = res[0];
        this.addMarker();
      }
    });
  },

  beforeDestroy() {
    this.markers?.forEach((item) => {
      item.off("click", this.onMarkerClick);
    });
    this.map?.clearMap();
    this.map?.destroy();
  },

  methods: {
    initMap() {
      const { AMap } = window;
      if (!AMap) {
        return;
      }
      var map = new AMap.Map("map", {
        center: [118.536766,32.993047],
        zoom: 16,
        mapStyle: "amap://styles/light",
        // mapStyle: "amap://styles/f3c7464cbaf52050e35d00dc506f4069",
      });

      this.map = map;
    },

    addMarker() {
      if (Array.isArray(this.markers)) {
        this.markers.forEach((item) => {
          item.off("click", this.onMarkerClick);
        });
      }
      this.markers = [];
      this.map?.clearMap();
      const key = this.selected;
      const obj = this.typeList.find((item) => item.value === key);
      const markers = this.list.map((item) => {
        let content = "";

        if (item.id === this.detail.id) {
          content = `
                <div style="background-color: #fff;white-space: nowrap;border-radius: 100px;border: 2px solid #f00;line-height: 32px;font-size: 14px;display: flex;align-items: center; padding: 0 8px ">
                      <img src='/icon/water-quality-active.png' style="height: 18px;margin-right: 8px;border-radius: 50%;border: 2px solid #f00"  />
                        <span style='color: #f00'>${item.name}${
            obj ? obj.name : key
          }：${item.realtime ? item.realtime[key] : ""}</span>
              </div>
              `;
        } else {
          content = `
             <div style="background-color: #fff;white-space: nowrap;border-radius: 100px;border: 2px solid #9824f8;line-height: 32px;font-size: 14px;display: flex;align-items: center; padding: 0 8px ">
                      <img src='/icon/water-quality-active.png' style="height: 18px;margin-right: 8px"  />
                    <span>${item.name}${obj ? obj.name : key}：${
            item.realtime ? item.realtime[key] : ""
          }</span>
              </div>
          `;
        }

        const marker = new window.AMap.Marker({
          position: [item.x, item.y],
          content,
          extData: item,
        });

        marker.on("click", this.onMarkerClick);
        return marker;
      });

      this.map.add(markers);
      this.markers = markers;
    },

    onMarkerClick(e) {
      console.log(e);
      this.detail = e.target._opts.extData;
    },

    onSelect(key) {
      this.selected = key;
      this.addMarker();
    },
  },
};
</script>


<style lang="less" scoped>
#map {
  position: fixed;
  height: 105vh;
  width: 100vw;
  left: 0;
  top: 0;
}

.menu {
  position: fixed;
  top: 11vh;
  left: 1vw;
  background-color: #090d23;
  border-radius: 8px;
  //padding: 1vh;
  display: flex;
  align-items: center;
  cursor: pointer;
  border: 1px solid #065747;
  color:#adadad;
  padding: 0.8rem;

  .item {
    padding: 4px 12px;
  }

  .active {
    background-color: rgba(0, 255, 150, 0.2);
    border-radius: 6px;
    color: #00ff96;
    border-bottom: 1px solid #00ff96;
  }
}
</style>